import { render, staticRenderFns } from "./BaseReservationTable.vue?vue&type=template&id=d7596ede"
import script from "./BaseReservationTable.vue?vue&type=script&lang=js"
export * from "./BaseReservationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports